import { FaWhatsapp, FaXmark } from "react-icons/fa6";

export const ModalWraperGenieAcs = ({ isOpen, setIsOpen, title, children }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{
                background: "rgba(0, 0, 0, 0.7)",
                backdropFilter: "blur(4px)",
            }}
            onClick={() => setIsOpen(false)}
        >
            <div
                className="w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl transition-all duration-300 transform scale-100"
                style={{
                    background: "rgba(15, 23, 42, 0.95)",
                    border: "1px solid rgba(51, 65, 85, 0.4)",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header Modal */}
                <div
                    className="flex items-center justify-between px-6 py-4"
                    style={{
                        borderBottom: "1px solid rgba(51, 65, 85, 0.3)",
                        background: "rgba(15, 23, 42, 0.8)",
                    }}
                >
                    <h3 className="text-lg font-bold text-gray-100 flex items-center gap-2">
                        <FaWhatsapp className="text-cyan-500" />
                        {title}
                    </h3>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="text-slate-400 hover:text-white transition-colors p-1"
                    >
                        <FaXmark className="text-xl" />
                    </button>
                </div>

                {/* Body Modal */}
                <div className="p-6">{children}</div>
            </div>
        </div>
    );
};